import React, { useContext, useEffect, useState } from 'react';
import { getTCards_ByID, postTcardsAddUpdate } from '../../../Core/Service/checkInRole';
import {
    Button,
    Grid,
    Typography,
    Paper,
    Checkbox,
    FormControlLabel,
    FormLabel,
    FormHelperText,
    TableCell,
    TableRow,
    TableContainer,
    Table,
    TableHead,
    TableBody,
    InputAdornment,
    InputLabel
} from '@material-ui/core';
import { PrimaryButton, SelectBox, TextBox, YesNoButton } from '../../../Core/FormInput';
import { makeStyles, withStyles } from '@material-ui/styles';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { CustomeSignPad } from '../../../Core/SignaturePad';
import DialogComp from '../../../Core/Modal/dialogModal';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import formatters from '../../../Core/Grid/inputFormatter';
import AppContext from '../../../App/AppContext';
import { useWindowSize } from '../../../Core/Controls/ScreenResolution';
import { LoanVehicleRegListByBranch } from '../../../Core/Service/loanVehicleUsage-service';
import DriverTermsNdCondition from './driverTermsndCondition';

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: 15
    },
    inputBase: {
        '&.MuiFormControl-fullWidth': {
            // background: 'white'
            // border: '1px solid rgba(0, 0, 0, 0.3)'
        },
        '& .MuiOutlinedInput-inputMarginDense': {
            padding: '13px',
            border: 'none',
            background: 'white',
            borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
            borderTop: '1px solid rgba(0, 0, 0, 0.3)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
        },
        '.MuiInputBase-root': {
            background: 'white',
            borderLeft: '1px solid rgba(0, 0, 0, 0.3)',
            borderTop: '1px solid rgba(0, 0, 0, 0.3)',
            borderBottom: '1px solid rgba(0, 0, 0, 0.3)'
        }
    },
    table: {
        minWidth: 850
    },
    title: {
        color: '#f50057',
        marginLeft: 8,
        marginTop: 8,
        marginBottom: 8
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        border: '1px solid rgba(0,0,0,0.2)'
    },
    axelTitles: {
        textAlign: 'center',
        color: '#f50057',
        width: '100%'
    },
    headings: {
        color: '#f50057',
        margin: 0,
        marginLeft: -4,
        marginBottom: 20
    }
}));
const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:hover': {
            backgroundColor: 'grey',
            color: 'white'
        },
        cursor: 'pointer'
    }
}))(TableRow);

const StyledTableCell = withStyles((theme) => ({
    head: {
        // padding: ' 5px',
        fontSize: 15,
        fontWeight: 600,
        backgroundColor: '#bdbdbd82'
    },
    body: {
        fontSize: 14
        // padding: ' 5px'
        // fontSize: 11,
    }
}))(TableCell);

const AddEditCheckIn = (props) => {
    const { showToast, showModal, portalSettings } = useContext(AppContext);
    const classes = useStyles();
    const [btnLoader, setBtnLoader] = useState(false);
    const [width, height] = useWindowSize();
    const [searchVehicleList, setSearchVehicleList] = useState([]);

    const [formData, setFormData] = useState({
        tCardsID: '',
        tCardsCustomerID: '',
        tCardsBranchID: '',
        tCardsVehicleID: '',
        loanVehicleID: '',
        loanVehicleUsageRegistrationNumber: '',
        tCardsRegistrationNumber: '',
        tCardsBookingDate: '',
        tCardsLoanVehicle: false,
        tCardsIsCollectionDeliver: false,
        tCardsIsCustomerWaiting: false,
        tCardsStatusID: '',
        tCardsContactNumber: '',
        tCardsContactName: '',
        tCardsServiceAdvisorSignature: '',
        tCardsPaymentTypeID: '',
        tCardsMileage: '',
        tCardsLocation: '',
        tCardsHeaderRecordID: '',
        tCardsDeadlineDate: '',
        tCardsCustomerOrderNumber: '',
        tCardsCustomerSignature: '',
        tCardsCustomerName: '',
        tCardsAgentSignature: '',
        tCardsAgentName: '',
        tCardsIsService: false,
        tCardsIsMOT: false,
        tCardsIsInspection: false,
        tCardsIsRepair: false,
        tCardsIsNightShift: false,
        tCardsCustomerPrintName: '',
        errors: {},
        customers: [],
        branches: [],
        payments: [],
        tCardLineStatus: [],
        tCardsEvents: [],
        tCardsStatus: [],
        tCardsTempEvents: [],
        tCardsLineItems: [],
        customersContactList: [],
        isRepair: false,
        errors: {},
        showTermAndCond: false,
        tCardsDriverTermsAndConditions: '',
        tCardsDriverName: '',
        tCardsDriverContactNumber: ''
    });

    useEffect(async () => {
        let res = await getTCards_ByID(props.selectedVehicle.tCardsID);

        if (res.success) {
            setFormData((st) => ({
                ...st,
                tCardsID: res.data.tCards[0].tCardsID,
                tCardsBranchID: res.data.tCards[0].tCardsBranchID,
                tCardsCustomerID: res.data.tCards[0].tCardsCustomerID,
                tCardsVehicleID: res.data.tCards[0].tCardsVehicleID,
                loanVehicleID: res.data.tCards[0].loanVehicleID,
                loanVehicleUsageRegistrationNumber: res.data.tCards[0].loanVehicleUsageRegistrationNumber,
                tCardsBookingDate: res.data.tCards[0].tCardsBookingDate,
                tCardsLoanVehicle: res.data.tCards[0].tCardsLoanVehicle,
                tCardsIsCollectionDeliver: res.data.tCards[0].tCardsIsCollectionDeliver,
                tCardsIsCustomerWaiting: res.data.tCards[0].tCardsIsCustomerWaiting,
                tCardsStatusID: res.data.tCards[0].tCardsStatusID,
                tCardsContactNumber: res.data.tCards[0].tCardsContactNumber,
                tCardsContactName: res.data.tCards[0].tCardsContactName,
                tCardsServiceAdvisorSignature: res.data.tCards[0].tCardsServiceAdvisorSignature,
                tCardsPaymentTypeID: res.data.tCards[0].tCardsPaymentTypeID,
                tCardsMileage: res.data.tCards[0].tCardsMileage,
                tCardsLocation: res.data.tCards[0].tCardsLocation,
                tCardsHeaderRecordID: res.data.tCards[0].tCardsHeaderRecordID,
                tCardsDeadlineDate: res.data.tCards[0].tCardsDeadlineDate ? formatters.DateTimeTHMSFormatter(res.data.tCards[0].tCardsDeadlineDate) : '',
                tCardsCustomerOrderNumber: res.data.tCards[0].tCardsCustomerOrderNumber,
                // tCardsCustomerSignature: res.data.tCards[0].tCardsCustomerSignature,
                tCardsCustomerName: res.data.tCards[0].tCardsCustomerName,
                tCardsAgentSignature: res.data.tCards[0].tCardsAgentSignature,
                tCardsAgentName: res.data.tCards[0].tCardsAgentName,
                tCardsIsService: res.data.tCards[0].tCardsIsService,
                tCardsIsMOT: res.data.tCards[0].tCardsIsMOT,
                tCardsIsNightShift: res.data.tCards[0].tCardsIsNightShift,
                tCardsIsInspection: res.data.tCards[0].tCardsIsInspection,
                tCardsIsRepair: res.data.tCards[0].tCardsIsRepair,
                tCardsCustomerPrintName: res.data.tCards[0].tCardsCustomerPrintName,
                tCardsRegistrationNumber: res.data.tCards[0].tCardsRegistrationNumber,
                tCardsDriverTermsAndConditions: res.data.tCardsDriverTermsAndConditions || '',
                tCardsLineItems: res.data.tCardsLineItems,

                tCardsIsTacho: res.data.tCards[0].tCardsIsTacho,
                tCardsIsRecallJob: res.data.tCards[0].tCardsIsRecallJob,
                tCardsDueDate: res.data.tCards[0].tCardsDueDate,
                tCardsCustomerAddress: res.data.tCards[0].tCardsCustomerAddress,
                tCardsMake: res.data.tCards[0].tCardsMake,
                tCardsModel: res.data.tCards[0].tCardsModel,
                tCardsPriorityID: res.data.tCards[0].tCardsPriorityID,
                tCardsCustomerOrderNumber: res.data.tCards[0].tCardsCustomerOrderNumber,
                tCardsIsBrakeTest: res.data.tCards[0].tCardsIsBrakeTest,
                tCardsMOTLocation: res.data.tCards[0].tCardsMOTLocation,
                tCardsMOTDate: res.data.tCards[0].tCardsMOTDate,
                tCardsDriverName: res.data.tCards[0].tCardsDriverName,
                tCardsDriverContactNumber: res.data.tCards[0].tCardsDriverContactNumber
            }));
        }
    }, []);

    useEffect(() => {
        if (formData.tCardsBranchID) {
            const searchLoanVehicle = async () => {
                let res = await LoanVehicleRegListByBranch(formData.tCardsBranchID, props.selectedVehicle.tCardsID);
                if (res.success) {
                    let data = res?.data?.list || [];
                    setSearchVehicleList(data.map((k) => ({ ...k, id: k.loanVehicleID, name: k.regNo })) || []);
                }
            };
            return searchLoanVehicle();
        }
    }, [formData.tCardsBranchID]);

    const handleVehicleDetails = (e) => {
        const { name, value } = e.target;
        setFormData((st) => {
            let newSt = { ...st };
            newSt[name] = value;
            return newSt;
        });
    };

    const handleClick = (name, val) => {
        setFormData((st) => {
            const nst = { ...st, [name]: val };
            // if (name == 'tCardsIsCustomerWaiting' && val == true) {
            //     nst.tCardsDeadlineDate = '';
            // }
            return nst;
        });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        console.log(name, value, type, checked);

        setFormData((prev) => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    };

    const closeWarningModal = (res) => {
        setFormData((st) => {
            let newSt = { ...st };
            newSt.showJobPopup = false;
            newSt.showTermAndCond = false;
            newSt.selectedLineEventDesc = '';
            return newSt;
        });
    };

    const addRepairLine = () => {
        setFormData((prev) => ({ ...prev, showJobPopup: true, isRepair: true }));
    };

    const handleValidation = () => {
        let errors = {};
        let formIsValid = true;
        if (!formData.tCardsIsCustomerWaiting && !formData.tCardsDeadlineDate) {
            formIsValid = false;
            errors['tCardsDeadlineDate'] = 'This field is required.';
        }
        if (!formData.tCardsCustomerSignature) {
            formIsValid = false;
            errors['tCardsCustomerSignatureAndName'] = 'Name and signature are required.';
        }
        if (!formData.tCardsCustomerPrintName) {
            formIsValid = false;
            errors['tCardsCustomerSignatureAndName'] = 'Name and signature are required.';
        }
        if (!formData.tCardsMileage) {
            formIsValid = false;
            errors['tCardsMileage'] = 'This field is required.';
        }
        if (formData.tCardsLoanVehicle && !formData.loanVehicleID) {
            formIsValid = false;
            errors['loanVehicleID'] = 'This field is required.';
        }
        if (formData.tCardsLoanVehicle && !formData.tCardsLocation) {
            formIsValid = false;
            errors['tCardsLocation'] = 'This field is required.';
        }

        setFormData((st) => ({
            ...st,
            errors: errors
        }));
        return formIsValid;
    };

    const handleSubmit = async () => {
        if (handleValidation()) {
            setBtnLoader(true);
            let data = {
                tCardsID: props.selectedVehicle.tCardsID,
                tCardsBranchID: formData.tCardsBranchID,
                tCardsCustomerID: formData.tCardsCustomerID,
                tCardsVehicleID: formData.tCardsVehicleID,
                loanVehicleID: formData.loanVehicleID,
                tCardsBookingDate: formData.tCardsBookingDate,
                tCardsLoanVehicle: formData.tCardsLoanVehicle,
                tCardsIsCollectionDeliver: formData.tCardsIsCollectionDeliver,
                tCardsIsCustomerWaiting: formData.tCardsIsCustomerWaiting,
                tCardsStatusID: 16, //2, //formData.tCardsStatusID,
                tCardsContactNumber: formData.tCardsContactNumber,
                tCardsContactName: formData.tCardsContactName,
                tCardsServiceAdvisorSignature: formData.tCardsServiceAdvisorSignature,
                tCardsPaymentTypeID: formData.tCardsPaymentTypeID,
                tCardsMileage: formData.tCardsMileage,
                tCardsLocation: formData.tCardsLocation,
                tCardsHeaderRecordID: formData.tCardsHeaderRecordID,
                tCardsDeadlineDate: formData.tCardsDeadlineDate,
                tCardsCustomerOrderNumber: formData.tCardsCustomerOrderNumber,
                tCardsCustomerSignature: formData.tCardsCustomerSignature,
                tCardsCustomerName: formData.tCardsCustomerName,
                tCardsAgentSignature: formData.tCardsAgentSignature,
                tCardsAgentName: formData.tCardsAgentName,
                tCardsIsService: formData.tCardsIsService,
                tCardsIsMOT: formData.tCardsIsMOT,
                tCardsIsNightShift: formData.tCardsIsNightShift,
                tCardsIsInspection: formData.tCardsIsInspection,
                tCardsIsRepair: formData.tCardsIsRepair,
                tCardsCustomerPrintName: formData.tCardsCustomerPrintName,
                tCardsRegistrationNumber: formData.tCardsRegistrationNumber,
                TCardLineItems:
                    formData.tCardsLineItems ||
                    // .filter((q) => !q.tCardsLineItemsID)
                    [],
                tCardsDriverTermsAndConditions: formData.tCardsDriverTermsAndConditions || '',
                tCardsIsTacho: formData.tCardsIsTacho,
                tCardsIsRecallJob: formData.tCardsIsRecallJob,
                tCardsDueDate: formData.tCardsDueDate,
                tCardsCustomerAddress: formData.tCardsCustomerAddress,
                tCardsMake: formData.tCardsMake,
                tCardsModel: formData.tCardsModel,
                tCardsPriorityID: formData.tCardsPriorityID,
                tCardsCustomerOrderNumber: formData.tCardsCustomerOrderNumber,
                tCardsIsBrakeTest: formData.tCardsIsBrakeTest,
                tCardsMOTLocation: formData.tCardsMOTLocation,
                tCardsMOTDate: formData.tCardsMOTDate,
                tCardsDriverName: formData.tCardsDriverName,
                tCardsDriverContactNumber: formData.tCardsDriverContactNumber
            };
            console.log(data);
            try {
                let res = await postTcardsAddUpdate(data);
                if (res?.data?.success) {
                    showToast('Vehicle checked in successfully');
                    props.onClose(true);
                } else if (res.errors) {
                    for (const [key, value] of Object.entries(res?.errors)) {
                        showToast(`${key}: ${value}`);
                    }
                } else {
                    showToast(res.message);
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                showToast('An error occurred while submitting the form.');
            }
            setBtnLoader(false);
        }
    };

    const handleLineEventValidation = () => {
        let errors = {};
        let formIsValid = true;

        // if (!formData.selectedLineEventDesc) {
        //     formIsValid = false;
        //     errors['selectedLineEventDesc'] = 'Please enter description.';
        // }
        // if (!formData.selectedLineEventAllHrs) {
        //     formIsValid = false;
        //     errors['selectedLineEventAllHrs'] = 'Please enter allocated hours.';
        // }

        setFormData((st) => ({
            ...st,
            errors: errors
        }));
        return formIsValid;
    };

    const GetTechnicianSign = (val) => {
        setFormData((st) => ({
            ...st,
            ...val
        }));
    };

    const handleLineEventSubmit = () => {
        if (handleLineEventValidation()) {
            let tempList = [
                ...formData.tCardsLineItems,
                {
                    tCardsLineItemsID: null,
                    tCardsLineItemsTCardsID: '', /// need to check
                    tCardsLineItemsDescription: formData.selectedLineEventDesc,
                    tCardsLineItemsEventTypeID: 4,
                    tCardsLineItemsAllocatedHours: '',
                    tCardsLineItemsSpentHours: 0,
                    tCardsLineItemsLineStatusID: '',
                    event: 'Repair'
                }
            ];

            setFormData((prev) => ({
                ...prev,
                tCardsLineItems: tempList,
                showJobPopup: false,
                selectedLineEventDesc: '',
                selectedLineEventAllHrs: '',
                isRepair: false
            }));
        }
    };

    const SetShowTermAndCond = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setFormData((st) => ({
            ...st,
            showTermAndCond: true
        }));
    };

    const handleTermsAndCondition = (e) => {
        setFormData((st) => ({
            ...st,
            isTermsAndCondition: e.target.checked,
            tCardsDriverTermsAndConditions: e.target.checked ? portalSettings.portalSettingsTermsOfService : true,
            showTermAndCond: false
        }));
    };
    const setTermsAndConditions = (flag) => {
        setFormData((st) => ({
            ...st,
            isTermsAndCondition: flag,
            tCardsDriverTermsAndConditions: flag ? portalSettings.portalSettingsTermsOfService : true,
            showTermAndCond: false
        }));
    };

    const removeRepairLine = (index) => {
        let tempList = [...formData.tCardsLineItems];
        tempList.splice(index, 1);
        setFormData((prev) => ({ ...prev, tCardsLineItems: tempList }));
    };

    const clearSig = (val) => {
        setFormData((st) => ({
            ...st,
            tCardsCustomerSignature: null
        }));
    };

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} md={4} lg={3}>
                            <FormLabel component="legend" error required>
                                Mileage
                            </FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsMileage"
                                value={formData.tCardsMileage}
                                onChange={handleChange}
                                autoFocus={true}
                                inputProps={{ maxLength: 10 }}
                            />
                            <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsMileage']}</FormHelperText>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Grid item xs={12} style={{ marginBottom: '5px' }}>
                                <FormLabel>Loan vehicle Required?</FormLabel>
                            </Grid>
                            <YesNoButton
                                state={formData.tCardsLoanVehicle}
                                name="tCardsLoanVehicle"
                                onYesClick={() => handleClick('tCardsLoanVehicle', true)}
                                onNoClick={() => handleClick('tCardsLoanVehicle', false)}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3} style={{ position: 'relative' }}>
                            <InputLabel error={formData.tCardsLoanVehicle} required={formData.tCardsLoanVehicle} style={{ marginBottom: '8px' }}>
                                Loan Vehicle Reg
                            </InputLabel>
                            <SelectBox
                                List={searchVehicleList}
                                name="loanVehicleID"
                                value={formData.loanVehicleID}
                                onChange={handleVehicleDetails}
                                autoFocus
                                // disabled={formData.loanVehicleUsageRegistrationNumber ? true : false}
                            />
                            {formData.errors.loanVehicleID && <FormHelperText error>{formData.errors.loanVehicleID}</FormHelperText>}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <Grid item xs={12} style={{ marginBottom: '5px' }}>
                                <FormLabel>Are you waiting on site?</FormLabel>
                            </Grid>
                            <YesNoButton
                                state={formData.tCardsIsCustomerWaiting}
                                name="tCardsIsCustomerWaiting"
                                onYesClick={() => handleClick('tCardsIsCustomerWaiting', true)}
                                onNoClick={() => handleClick('tCardsIsCustomerWaiting', false)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {/* {formData.tCardsIsCustomerWaiting == false && ( */}
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <FormLabel component="legend" error required>
                                Vehicle Required By (Date/time)
                            </FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsDeadlineDate"
                                type="datetime-local"
                                onChange={handleChange}
                                InputLabelProps={{ shrink: true }}
                                value={formData.tCardsDeadlineDate}
                            />
                            <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsDeadlineDate']}</FormHelperText>
                        </Grid>
                        {/* )} */}
                        <Grid item xs={12} sm={12} md={4} lg={3}>
                            <FormLabel component="legend" error={formData.tCardsLoanVehicle} required={formData.tCardsLoanVehicle}>
                                Location
                            </FormLabel>
                            <TextBox fullWidth name="tCardsLocation" value={formData.tCardsLocation} onChange={handleChange} autoFocus={true} />
                            <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsLocation']}</FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={3}>
                            <FormLabel component="legend">Driver Name</FormLabel>
                            <TextBox fullWidth name="tCardsDriverName" value={formData.tCardsDriverName} onChange={handleChange} autoFocus={true} />
                            <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsDriverName']}</FormHelperText>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={3}>
                            <FormLabel component="legend">Driver Number</FormLabel>
                            <TextBox
                                fullWidth
                                name="tCardsDriverContactNumber"
                                value={formData.tCardsDriverContactNumber}
                                onChange={handleChange}
                                autoFocus={true}
                            />
                            <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsDriverContactNumber']}</FormHelperText>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <TableContainer style={{ height: width < '599' ? 350 : 'calc(100vh - 630px)', border: '1px solid rgba(0,0,0,0.2)' }}>
                        <Table className={classes.table} size="small">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell width="2%">
                                        <AddBoxIcon onClick={addRepairLine} style={{ verticalAlign: 'middle' }} />
                                    </StyledTableCell>
                                    <StyledTableCell width="10%">Event Type</StyledTableCell>
                                    <StyledTableCell width="75%">Description/Comments</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {formData.tCardsLineItems.map((q, i) => {
                                    return (
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                {!q.tCardsLineItemsID && <RemoveCircleIcon onClick={() => removeRepairLine(i)} />}
                                            </StyledTableCell>
                                            <StyledTableCell>{q.event}</StyledTableCell>
                                            <StyledTableCell>{q.tCardsLineItemsDescription}</StyledTableCell>
                                        </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid
                    item
                    xs={12}
                    md={12}
                    lg={6}
                    style={{
                        width: '100%',
                        height: '300px'
                    }}
                >
                    <FormLabel component="legend" error required>
                        Name
                    </FormLabel>
                    <label style={{ cursor: 'pointer' }}>
                        {`     `}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <input type="checkbox" checked={formData.isTermsAndCondition} onChange={handleTermsAndCondition} style={{ marginRight: '8px' }} />I
                        agree to the &nbsp;
                        <span onClick={SetShowTermAndCond} style={{ color: 'blue', textDecoration: 'underline' }}>
                            Terms and Conditions
                        </span>
                    </label>
                    <TextBox fullWidth name="tCardsCustomerPrintName" value={formData.tCardsCustomerPrintName} onChange={handleChange} />
                    <CustomeSignPad
                        style={{ height: '180px' }}
                        onChange={GetTechnicianSign}
                        clearSig={clearSig}
                        content={<span>Signature</span>}
                        name="tCardsCustomerSignature"
                        hideBtn={false}
                        hideDefaultSignBtn={true}
                        isRequired={true}
                    />
                </Grid>
                {formData.errors['tCardsCustomerSignatureAndName'] && (
                    <Grid item xs={12}>
                        <FormHelperText style={{ color: 'red' }}>{formData.errors['tCardsCustomerSignatureAndName']}</FormHelperText>
                    </Grid>
                )}

                <Grid item xs={12}>
                    <PrimaryButton fullWidth onClick={handleSubmit} isBtnLoader={btnLoader} disabled={formData.isTermsAndCondition ? false : true}>
                        Check In
                    </PrimaryButton>
                </Grid>
            </Grid>
            {formData.showJobPopup ? (
                <DialogComp title={'Add Defect'} maxWidth="sm" onClose={() => closeWarningModal(false)} fullWidth overflow="auto">
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            <FormLabel component="legend">Description</FormLabel>
                            <TextBox fullWidth name="selectedLineEventDesc" value={formData.selectedLineEventDesc} onChange={handleChange} autoFocus={true} />
                            <FormHelperText style={{ color: 'red' }}>{formData.errors['selectedLineEventDesc']}</FormHelperText>
                        </Grid>
                        {/* <Grid item xs={12}>
                            <FormLabel component="legend">Allocated Hours</FormLabel>
                            <TextBox fullWidth name="selectedLineEventAllHrs" value={formData.selectedLineEventAllHrs} onChange={handleChange} />
                            <FormHelperText style={{ color: 'red' }}>{formData.errors['selectedLineEventAllHrs']}</FormHelperText>
                        </Grid> */}

                        <Grid item xs={12}>
                            <Button variant="contained" color="primary" fullWidth onClick={handleLineEventSubmit}>
                                Submit
                            </Button>
                        </Grid>
                    </Grid>
                </DialogComp>
            ) : null}
            {formData.showTermAndCond ? (
                <DialogComp title={'Terms and Condition'} maxWidth="sm" onClose={() => closeWarningModal(false)} fullWidth overflow="auto">
                    <DriverTermsNdCondition
                        onSubmit={setTermsAndConditions}
                        termsOfService={portalSettings.portalSettingsTermsOfService}
                        onClose={() => closeWarningModal(false)}
                    />
                </DialogComp>
            ) : null}
        </div>
    );
};

export default AddEditCheckIn;
